const AUTH = (state, data) => {
  localStorage.setItem('api_token', data.token.token)
  localStorage.setItem('api_refreshToken', data.token.refreshToken)
  state.auth.token = data.token.token
  state.auth.refreshToken = data.token.refreshToken
}

const CHECK = state => {
  state.auth.token = localStorage.getItem('api_token')
  state.auth.refreshToken = localStorage.getItem('api_refreshToken')
}

const LOGIN = (state, userData) => {
  state.logged = true
  state.usuario = userData
  localStorage.setItem('api_usuario', userData)
}

const LOGOUT = state => {
  state.logged = false
  state.usuario = {}
  state.auth = {
    token: null,
    refresh_token: null
  }
  localStorage.removeItem('api_token')
  localStorage.removeItem('api_refreshToken')
  localStorage.removeItem('api_usuario')
  if (localStorage.getItem('api_lembrar') === 'false') {
    localStorage.removeItem('api_login')
  }
}

export default {
  AUTH,
  CHECK,
  LOGIN,
  LOGOUT
}
